import { Action, createAction } from 'redux-act';

import CompanyPayload from './CompanyPayload';
import EmployeePayload from './EmployeePayload';

export interface DeleteEmployeePayload extends EmployeePayload, CompanyPayload {}
export const deleteEmployee = createAction<DeleteEmployeePayload>('DELETE_EMPLOYEE');
export type DeleteEmployeeActionType = Action<DeleteEmployeePayload>;

export interface EmployeeDeletedPayload extends EmployeePayload, CompanyPayload {}
export const employeeDeleted = createAction<EmployeeDeletedPayload>('EMPLOYEE_DELETED');

export interface EmployeeDeleteFailedPayload extends EmployeePayload, CompanyPayload {}
export const employeeDeleteFailed = createAction<EmployeeDeleteFailedPayload>('EMPLOYEE_DELETE_FAILED');

export type DeleteEmployeeResultPayload = EmployeeDeletedPayload | EmployeeDeleteFailedPayload;
